import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DossierService } from '../../services/frapper/dossier.service';
import { UsercourrierService } from '../../services/frapper/usercourrier.service';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { AlertesService } from '../../services/public/alertes.service';
import { SuccessDialogComponent } from '../../widgets/successDialog/success-dialog.component';
import { AddPieceComponent } from '../add-piece/add-piece.component';
import * as $ from 'jquery';
import {NaturalisationService} from "../../services/frapper/naturalisation.service";
import {CustomService} from "../../services/frapper/custom.service";
import { MyCONST } from '../../CONST/myConst';
import { VisualizePieceComponent } from '../visualize-piece/visualize-piece.component';


@Component({
  selector: 'app-add-naturalisation',
  templateUrl: './add-naturalisation.component.html',
  styleUrls: ['./add-naturalisation.component.scss']
})
export class AddNaturalisationComponent {

  @Input() parentModal: BsModalRef;
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  data: any;
  type:any;
  modalRef!: BsModalRef;
  classifications:any =[];
  natures:any =[];
  selectedPiece: any = null;
  selectedFichier: any = null;
  my_tribunal:any = null
  pageficheNaturalisation:number = 1
  formValues: { [key: string]: any } = {};

  fieldNames = [
    'date_de_demande',
    'nom',
    'prenom',
    'date_de_naissance',
    'lieu_de_naissance',
    'pays_dorigine',
    'sexe',
    'numero_de_telephone',
    'profession',
    'adresse_de_lemployeur',
    'prenom_et_nom_de_la_mere',
    'prenom_du_pere',
    'nationalite_d_origine',
    'numero_de_dossier',
    'date_d_arrivée',
    'numero_de_courrier',
    'demande_manuscrite_garde_des_sceaux',
    'acte_de_naissance',
    'casier_judiciaire_b3',
    'attestation_dimposition_ou_non',
    'certificat_de_residence',
    'certificat_de_bonne_vie_et_moeurs',
    'certificat_de_visite_contre_visite',
    'acte_de_mariage',
    'extrait_de_naissance_du_de_la_conjoint_e',
    'extrait_de_naissance_des_enfants',
    'piece_investissement',
    'piece_travail'
  ];

  fichiersNaturalisations: any[] = [
    {
      name:'demande_manuscrite_garde_des_sceaux',
      labelle: 'Demande manusc. garde des sceaux'
    },
    {
      name:'acte_de_naissance',
      labelle: 'Acte de naissance'
    },
    {
      name:'acte_de_naissance',
      labelle: 'Acte de naissance'
    },
    {
      name:'casier_judiciaire_b3',
      labelle: 'Casier judiciaire B3'
    },
    {
      name:'attestation_dimposition_ou_non',
      labelle: 'Attest. imposition'
    },
    {
      name:'certificat_de_residence',
      labelle: 'Certificat de residence'
    },
    {
      name:'certificat_de_bonne_vie_et_moeurs',
      labelle: 'Certificat de bonne vie et moeurs'
    },
    {
      name:'certificat_de_visite_contre_visite',
      labelle: 'Certificat de visite contre visite'
    },
    {
      name:'acte_de_mariage',
      labelle: 'Acte de mariage'
    },
    {
      name:'extrait_de_naissance_du_de_la_conjoint_e',
      labelle: 'Extrait naissance conjointe'
    },
    {
      name:'extrait_de_naissance_des_enfants',
      labelle: 'Extrait naissance enfants'
    },
    {
      name:'piece_investissement',
      labelle: 'Piece investissement'
    },
    {
      name:'piece_travail',
      labelle: 'Piece travail'
    },
    
  ];
  list_pieces_getted = []
  couples: Array<{ piece: any, fichier: any }> = [];

  imageFile:any ={}

  constructor(private modalService: BsModalService,
              private naturalisation: NaturalisationService,
              public options: ModalOptions,
              private custom: CustomService,
              private naturalisationService: NaturalisationService,
              private dossierService:DossierService,
              private ngxService: NgxUiLoaderService,
              private alerte:AlertesService,
              public bsModalRef: BsModalRef,
              private userCourrierService:UsercourrierService,
              private penalService: PenalCourrierService) {
    this.data = options.initialState.data
    console.log('the data====> ', this.data)
    console.log('the type====> ', this.type)
    try{
      this.my_tribunal = JSON.parse(localStorage.getItem('my_tribunal'))
      //console.log('tribunal_information====> ',tribunal_information)
    }catch (e) {
      console.log('ERROR ON GET TRIBUNAL====> ')
      this.my_tribunal=null
    }

  }


  openModalVisualPiece(key) {
    const URL=MyCONST.API_URL+key
    console.log('urllll ', URL);
    const config: ModalOptions = {
      initialState: {
        data: URL,
        url:URL,

        parentModal : null
      }
    }



    // Ouvrir le modal
    const modalRef = this.modalService.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg ' }));

    // Mettre à jour l'option initialState avec le modalRef
  }

  selectPiece(item: any) {
    this.selectedPiece = item;
  }

  selectFichier(item: any) {
    this.selectedFichier = item;
  }

  createCouple() {
    if (this.selectedPiece && this.selectedFichier) {
      // Ajouter le couple
      this.couples.push({
        piece: this.selectedPiece,
        fichier: this.selectedFichier,
        
      });

      // Supprimer les éléments des listes initiales
      this.list_pieces_getted = this.list_pieces_getted.filter(p => p !== this.selectedPiece);
      this.fichiersNaturalisations = this.fichiersNaturalisations.filter(f => f !== this.selectedFichier);

      // Réinitialiser les sélections
      this.selectedPiece = null;
      this.selectedFichier = null;
    }
  }

  removeCouple(couple: any) {
    // Réinjecter dans les listes
    this.list_pieces_getted.push(couple.piece);
    this.fichiersNaturalisations.push(couple.fichier);

    // Supprimer du tableau de couples
    this.couples = this.couples.filter(c => c !== couple);
  }

  openModalSuccessDialog(message: string) {
    const config: ModalOptions = {
      initialState: {
        message: message
      }
    };
    this.modalRef.hide()
    this.modalRef = this.modalService.show(SuccessDialogComponent, Object.assign({}, config, {class:'modal-sm'}));
  }

  openModalAddPiece() {

    const config: ModalOptions = {
      initialState: {
        // message: message
      }
    };
    // this.penalService.hiddeModal(this.parentModal);
    this.modalRef = this.modalService.show(AddPieceComponent, Object.assign({}, config, {class:'modal-lg  '}));
  }

  hidde() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  closeModal(){
    this.bsModalRef.hide()
  }


  closeWithMessage(message: string) {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.emit(message); 
  }

  initializeStepper() {
    console.log('innnnn ssteppp 31  '+this.type );
    var stepFirst = this.type;

    $(document).ready(function(){
      var current_fs, next_fs, previous_fs; //fieldsets
      var opacity;
      var current = 1;
      var steps = $("fieldset").length;


      setProgressBar(current);



      if (stepFirst == 'step3') {
        console.log('in step333 === '+ stepFirst);


        $("fieldset.step1").hide();
        $("fieldset#step1").addClass("active");
        $("fieldset.step2").hide();
        $("#step2").addClass("active");
          // Afficher le fieldset de classe step3
          $("fieldset.step3").show();
        // $("fieldset").eq(2).show();
        current = 4;
        setProgressBar(current++);

        // Ajouter la classe "active" au deuxième élément de la barre de progression
        $("#progressbar li").eq(2).addClass("active");
        console.log("Au moins un élément fieldset a la classe 'cache'");
      }




      // Fonction pour définir la barre de progression
      function setProgressBar(curStep){
          var percent = (100 / steps) * curStep;
          percent = percent
          $(".progress-bar").css("width",percent+"%");
      }

      // Logique pour passer à l'étape suivante
      $(".next").click(function(){
          current_fs = $(this).parent();
          next_fs = $(this).parent().next();

          // Ajouter la classe "active" à l'étape suivante de la barre de progression
          $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

          // Afficher le fieldset suivant avec une animation
          next_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  next_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(++current);
      });

      // Logique pour revenir à l'étape précédente
      $(".previous").click(function(){
          current_fs = $(this).parent();
          previous_fs = $(this).parent().prev();

          // Retirer la classe "active" de l'étape actuelle de la barre de progression
          $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

          // Afficher le fieldset précédent avec une animation
          previous_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  previous_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(--current);
      });
  });
  }


  onFileSelected(event: any,key) {

    let image:any = event.target.files[0] as File;
    console.log('this.imageFile ==> ',this.imageFile)
    this.createPiece(image,key)
  }

  createPiece(file,key){
    this.ngxService.start();

    const formData1= new FormData();
    formData1.append('is_private', '0');
    formData1.append('file',file);

    this.custom.createFiles(formData1).then(res =>{
      //console.log('IN FILE ==> ',res)
      this.imageFile[key]=res.message.file_url
      this.ngxService.stop();
    },err =>{
      //console.log('IN UPLOAD FILE ERR ==> ',err)
      this.ngxService.stop();
      this.alerte.errorNotification('Pieces','Une erreur s\'est produite!')
    })
  }

  AddNewNaturalisation(form: NgForm){
    if (form.valid) {
      this.ngxService.start();
      let init_step =''
  
      let body_content = form.value
      if(this.my_tribunal !=null){
        body_content["tribunal"]= this.my_tribunal.name
      }
      body_content["statut"]="En cours"
      body_content["docstatus"]= 1
  
      //console.log('DataFormValue 1', body_content);
  
      if (this.couples.length == 0) {
        const ImagesCharged = Object.keys(this.imageFile);
        for (let key of ImagesCharged){
          body_content[key] = this.imageFile[key]
        }
      }else{
          // Ajouter les fichiers issus de couples
        for (let item of this.couples) {
          const key = item.fichier.name;
          const value = item.piece.fichier;
          body_content[key] = value;
        }
      }
     
     
    
      
      
      
  
      console.log('DataFormValue', body_content);
  
      // return
      this.naturalisation.nouvelleDemande(body_content).then((res) =>{
        console.log('ressss=>', res);
        
        this.alerte.successNotification('Naturalisation','Demande enregistrée avec success');
        this.closeWithMessage("success");
        this.ngxService.stop()
      },err =>{
        this.alerte.errorNotification('Erreur lors de l\'enregistrement')
        this.ngxService.stop();
      })
    }else{
      this.alerte.warningNotification('Remplissez les champs obligatoires')
    }
    




    // this.dossierService.nouveauDossier(dossier.value).then( (res:any) => {
    //   //console.log('REsult ---> ', res)
    //   this.dossierService.updateSatate(res.data.name,init_step).then(ress => {
        // this.openModalSuccessDialog('Dossier enregisté avec success')
        //   this.ngxService.stop();
    //   },
    //     error =>{
    //       this.alerte.errorNotification('Mise a jour du dossier','Impossible de mettre a jour le dossier')
    //       console.log('Error On update==> ',error)
    //       this.ngxService.stop();
    //     })
    // },
    //   error =>{
    //     this.alerte.errorNotification('Creation de dossier','Impossible de creer le dossier')
    //     console.log('Error ==> ',error)
    //     this.ngxService.stop();
    //   })


  }
  // async getOneCourrier(name){
  //  let courrier =  await this.naturalisation.getOneDemandes(this.data.name)
  //  if (courrier.data != null) {
  //   CAN_NATURALISATION = 
  //  }
  // }

  mapDataToFormValues(data: any): { [key: string]: any } {
    const mapped: { [key: string]: any } = {};
  
    if (!data) {
      console.warn('Aucune donnée à mapper');
      return mapped; // retourne un objet vide
    }

    

  
    let fieldMappings: { [key: string]: string };
    if (this.type == 'courrier') {
      // check if has not already on list naturalisation
      
      this.list_pieces_getted = data.pieces_jointe_au_courrier
      console.log('listpiecesguetted',this.list_pieces_getted);
      
      fieldMappings = {
        nom: 'nom',
        prenom: 'prenom',
        pays_dorigine: 'pays',
        numero_de_courrier: 'numero_courrier',
        numero_de_dossier:'numero_dossier',
        
        nationalite_d_origine: 'pays',
        date_d_arrivée: 'date_reception',
      };
    } else if (this.type == 'dossier') {
      this.list_pieces_getted = data.pieces_jointe_au_dossier
      fieldMappings = {
        nom: 'nom_demandeur',
        prenom: 'nom_complet_du_plaignant',
        pays_dorigine: 'pays',
        numero_de_courrier: 'numero_courrier',
        numero_de_dossier: 'name',
        date_de_naissance: 'date_de_naissance_du_plaignant',
        lieu_de_naissance: 'lieu_de_naissance_du_plaignant',
        prenom_et_nom_de_la_mere: 'nom_complet_de_la_mere_du_plaignant',
        prenom_du_pere: 'nom_complet_du_pere_du_plaignant',
        date_d_arrivée: 'date_reception',
      };
    } else {
      fieldMappings = {}; 
    }
  
    for (const field of this.fieldNames) {
      const sourceKey = fieldMappings[field] || field;
      mapped[field] = data[sourceKey] !== undefined ? data[sourceKey] : '';
    }
  
    return mapped;
  }
  

  initializeEmptyFormValues(): void {
     
  
    this.formValues = {};
    this.fieldNames.forEach(field => {
      this.formValues[field] = '';
    });
  }
  

  ngOnInit() {
    
    //console.log('This.data -----> ', this.data)
    // this.userCourrierService.getAllowedClassification().then( res =>{
    //   //console.log(res.data)
    //   this.classifications = res.data
    // })
    // this.userCourrierService.getAllowedNatureCourrier().then( res =>{
    //   console.log(res.data)
    //   this.natures = res.data
    // })
    //console.log('this.data ==> ',this.data)

    if (this.data) {
      this.formValues = this.mapDataToFormValues(this.data);
    } else {
      console.warn("Aucune donnée disponible pour préremplir le formulaire");
      this.formValues = this.mapDataToFormValues({}); // ou initialise un formulaire vide
    }


    var self = this;
    $(document).ready(function(){
      console.log('dddddd rrreeaady');

      self.initializeStepper();



    })

    $(document).ready(function() {
      $(".file-input").on("change", function() {
          // Récupérer le nom du fichier sélectionné
          const fileName = $(this).val().split("\\").pop();
          // Trouver l'élément span à l'intérieur du label parent et mettre à jour son texte
          $(this).parent().find('.file-label').text(fileName);
      });
  });

  }
}
